









































































































































































import CrearMovimiento from './CrearMovimiento.vue';
import EditarMovimiento from './EditarMovimiento.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Watch } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { eventBus, actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '../../components/Confirmation.vue';
import HandleErrors from '../../config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { utils, writeFileXLSX } from 'xlsx';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchMovimientos } from './fetchMovimientos';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    MantenedorGridSinCodigo,
    CrearMovimiento,
    EditarMovimiento,
    DatePicker,
    'app-confirmacion': Confirmation,
    FormFieldsContainer,
    AgGridVue,
  },
})
export default class MovimientoDispositivos extends ComponenteBase {
  ordesList: any[] = [];
  consulta: any = {
    dateStart: moment()
      .subtract(1, 'month')
      .startOf('day')
      .format('YYYY/MM/DD HH:mm'),
    dateEnd: moment()
      .endOf('day')
      .format('YYYY/MM/DD HH:mm'),
  };

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        Movimiento: e.movinumero,
        'Fecha Creación': moment(e.movifecha_alta).format('YYYY/MM/DD HH:mm'),
        Usuario: e.nombre,
        Destino: e.tipoubicaname,
        Estado: e.estado,
        Observación: e.moviobs,
        'Número Orden Despacho': e.despaseguimiento,
        'Caja Número': e.movicajanro,
        'Fecha Recibe': moment(e.movifecha_recibe).format('YYYY/MM/DD HH:mm'),
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Movimientos');
    writeFileXLSX(wb, 'Movimientos.xlsx');
    this.$snotify.success('Excel exportado con éxito', 3000);
  }

  funcionalidad: Funcionalidades = Funcionalidades.MovimientoDispositivos;
  usuario = JSON.parse(localStorage.getItem('user')).id;
  filtro: string = '';
  texto_reporte: string = '';
  showReporteGenerado: boolean = false;
  closeReporte() {
    this.showReporteGenerado = false;
  }

  async getMovimientos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMovimientos(
      {
        userId: this.usuario,
        destino: this.consulta.destino ? this.consulta.destino : '',
        estado: this.consulta.estado ? this.consulta.estado : '',
        dateStart: this.consulta.dateStart,
        dateEnd: this.consulta.dateEnd,
      },
      'conectaMoviDispositivos/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar los movimientos', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  usuarioActivo: any = {};
  async getUsuario() {
    let self = this;
    let user = JSON.parse(localStorage.getItem('user')).id;
    return fetchMovimientos(
      { userId: user },
      'conectaMoviDispositivos/getUsuario'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.usuarioActivo = data.data.data;
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar el usuario', {
          timeout: 3000,
        });
      });
  }

  despaAnterior: number;
  async getCodigo() {
    let self = this;
    return fetchMovimientos({ '': '' }, 'conectaMoviDispositivos/getCodigo')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.despaAnterior = parseInt(data.data.data.ult_movinumero);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al obtener el código', {
          timeout: 3000,
        });
      });
  }

  destinos: any = [];
  estados: any = [];
  operaciones: any = [];
  despachos: any = [];
  anuladoId: number;
  recibidoId: number;

  async getFilter() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMovimientos({ '': '' }, 'conectaMoviDispositivos/getFilter')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.destinos = data.data.DESTINO;
          this.estados = data.data.ESTADO;
          this.operaciones = data.data.OPERACIONES;
          this.despachos = data.data.DESPACHOS;
          this.anuladoId = data.data.MOVIESTADOS[0].moviestado_anulado;
          this.recibidoId = data.data.MOVIESTADOS[0].moviestado_recibido;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar los filtros', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  valorMax: number;
  codigosList: any[] = [];
  async datoEditado(dato: boolean) {
    if (dato) {
      this.ordesList = await this.getMovimientos();
      this.gridApi.setRowData(this.ordesList);
    }
  }

  async datoNuevo(dato: any) {
    this.ordesList = await this.getMovimientos();
    this.gridApi.setRowData(this.ordesList);
    await this.getCodigo();
    this.valorMax = this.despaAnterior + 1;
  }

  async handleGridReady(event: GridReadyEvent) {
    this.getUsuario();
    this.ordesList = await this.getMovimientos();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    await this.getFilter();
    await this.getCodigo();
    this.valorMax = this.despaAnterior + 1;
  }

  async filtrar() {
    if (this.formFields.dateStart.value > this.formFields.dateEnd.value) {
      this.$snotify.error(
        'La fecha de inicio no puede ser superior a la fecha fin',
        {
          timeout: 3000,
        }
      );
      return;
    }
    this.ordesList = [];
    this.gridApi.setRowData(this.ordesList);
    this.consulta = {
      destino: this.formFields.destino.value,
      estado: this.formFields.estado.value,
      dateStart: moment(this.formFields.dateStart.value.toString())
        .startOf('day')
        .format('YYYY/MM/DD HH:mm'),
      dateEnd: moment(this.formFields.dateEnd.value.toString())
        .endOf('day')
        .format('YYYY/MM/DD HH:mm'),
    };
    this.ordesList = await this.getMovimientos();
    this.gridApi.setRowData(this.ordesList);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  clearFilters() {
    this.formFields.destino.value = '';
    this.formFields.estado.value = '';
    this.formFields.dateStart.value = moment().subtract(1, 'month');
    this.formFields.dateEnd.value = moment();
    this.filtrar();
  }

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      value: '',
      id: '',
    },
    destino: {
      label: 'Destino',
      value: '',
      id: '',
    },
    dateStart: {
      label: 'Fecha Envío Desde',
      value: moment().subtract(1, 'month'),
      id: '',
    },
    dateEnd: {
      label: 'Fecha Envío Hasta',
      value: moment(),
      id: '',
    },
  };

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: true,
  };

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  VerPdf: PermisoAccion = {
    accionCodigo: 89,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionEditar,
    this.VerPdf,
  ];

  // Globales

  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;

  loadingService = new LoadingService();

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY/MM/DD HH:mm:ss');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Movimiento',
        field: 'movinumero',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 130,
        width: 130,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Creación',
        field: 'movifecha_alta',
        resizable: true,
        sortable: true,
        width: 170,
        minWidth: 170,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Usuario',
        field: 'nombre',
        resizable: true,
        sortable: true,
        width: 170,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Destino',
        field: 'tipoubicaname',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        width: 140,
        minWidth: 140,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Observación',
        field: 'moviobs',
        sortable: true,
        resizable: true,
        width: 260,
        minWidth: 260,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Número Orden Despacho',
        field: 'despaseguimiento',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Caja Número',
        field: 'movicajanro',
        width: 160,
        minWidth: 160,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Fecha Recibe',
        field: 'movifecha_recibe',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      makeAccionesColumnDef(this.funcionalidad),
    ];

    this.gridOptions = {
      localeText: {
        noRowsToShow: 'No se han encontrado movimientos',
      },
      pagination: true,
      paginationPageSize: 30, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,

      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  created() {
    this.initialize();
  }
  clienteDefecto = JSON.parse(localStorage.getItem('user')).clienteDefecto;
  async verPdf() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMovimientos(
      {
        user_id: this.usuario,
        movimiento: this.editedItem,
        clienteDefecto: this.clienteDefecto,
      },
      'conectaMoviDispositivos/exportar_pdf'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al exportar PDF', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.MovimientoDispositivos) {
        if (data.action === Accion.Editar) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;

          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.movinumero;
          }
        } else if (data.action === Accion.VerPdf) {
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.editedItem = data.cellRendererParams.data.movinumero;
          }
          this.verPdf();
        }
      }
    });
  }
  moduloModalCallback(val: boolean) {
    this.showModalNew = val;
    this.showModalEdit = val;
  }
}
